document.addEventListener('DOMContentLoaded', function () {
  function normalize(str) {
    return str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  document.querySelectorAll('.list-collection').forEach(function (wrapper) {
    var grid = wrapper.querySelector('.card-grid');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.media-card'));
    if (cards.length === 0) return;

    var searchWrap = document.createElement('div');
    searchWrap.className = 'collection-list-search';
    searchWrap.innerHTML =
      '<div class="collection-list-search__wrap">' +
    '<svg class="collection-list-search__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="11" cy="11" r="8"></circle>' +
      '<line x1="21" y1="21" x2="16.65" y2="16.65"></line>' +
    '</svg>' +
    '<input type="text" class="collection-list-search__input" placeholder="Najít můj klub...">' +
  '</div>';

    wrapper.insertBefore(searchWrap, grid);

    var input = searchWrap.querySelector('.collection-list-search__input');

    input.addEventListener('input', function () {
      var query = normalize(input.value.trim());

      cards.forEach(function (card) {
        var link = card.querySelector('a[aria-label]');
        var label = link ? normalize(link.getAttribute('aria-label')) : '';
        var match = query === '' || label.indexOf(query) !== -1;
        card.style.display = match ? '' : 'none';
      });
    });
  });
});